




















import {
PropType,
defineComponent,
useAsync,
useContext,
} from '@nuxtjs/composition-api';
import { CategoryTree } from '@vue-storefront/magento-api/lib/types/GraphQL';
import ProductsGrid from '~/cms/ProductsGrid.vue';
import { CmsLink, LinkTypes } from '~/cms/models/Link.model';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useProduct, useUiHelpers } from '~/composables';
import useRelatedProducts from '~/modules/catalog/product/composables/useRelatedProducts';
import { GetProductSearchParams, Product } from '~/modules/catalog/product/types';
import { useCategoryStore } from '../../category/stores/category';
import { CategoryInterface } from '../../category/types';

export default defineComponent({
  name: 'RelatedProducts',
  components: {
    ProductsGrid,
    SkeletonLoader,
  },
  props: {
    product: { type: [Object, null] as PropType<Product>, default: () => {} },
  },
  setup(props) {
    const { app: { i18n } } = useContext();
    const {
      search: searchRelatedProducts,
      loading,
    } = useRelatedProducts();
    const { getCatLink } = useUiHelpers();
    const { getProductListSkus } = useProduct();
    const categories = useCategoryStore();

    let lastLevelCategory : CategoryInterface = props.product.categories ? props.product.categories[0] : null;

    // Fetch lastLevel category, until the 3rd level
    props.product.categories.forEach((category: CategoryInterface) => {
      if (category.breadcrumbs?.length > lastLevelCategory.breadcrumbs?.length && category.breadcrumbs?.length < 3) {
        lastLevelCategory = category;
      }
    });

    const viewAllUrl = props.product.custom?.related_products_link || getCatLink(lastLevelCategory as CategoryTree);

    const viewAllLink : CmsLink[] = [{
      link: {
        _uid: lastLevelCategory.uid,
        url: viewAllUrl,
        cached_url: viewAllUrl,
        linktype: LinkTypes.URL,
      },
      label: String(i18n.t('View All')),
    }];

    const baseSearchQuery = {
      filter: {
        sku: {
          eq: props.product.sku,
        },
      },
    };

    const productsSkus = useAsync(async () => {
      const data = await searchRelatedProducts(baseSearchQuery);

      const getRandomProducts = (products, count) => {
        const result = [];
        const productIndices = new Set();

        while (productIndices.size < count) {
          const randomIndex = Math.floor(Math.random() * products.length);
          if (!productIndices.has(randomIndex)) {
            productIndices.add(randomIndex);
            result.push(products[randomIndex]);
          }
        }

        return result;
      };

      if (data.length === 0) {
        const categoriesRequests = props.product.categories.map(async (category: CategoryInterface) => categories.getByUid(String(category.uid)));
        const categoriesProperties = await Promise.all(categoriesRequests);
        // eslint-disable-next-line max-len
        const lowestCategory = categoriesProperties.reduce((prev, current) => (prev.categories.items[0].children.length >= current.categories.items[0].children.length ? current : prev));

        const searchParams: GetProductSearchParams = {
          filter: {
            category_uid: { eq: lowestCategory.categories.items[0].uid },
          },
        };

        const productsSkusData = await getProductListSkus(searchParams);
        const numberOfRandomProducts = 3;
        return productsSkusData.length < numberOfRandomProducts + 1
          ? productsSkusData
          : getRandomProducts(productsSkusData, numberOfRandomProducts);
      }
      return data.map((product: any) => product.sku).slice(0, 3);
    });

    return {
      productsSkus,
      loading,
      viewAllLink,
    };
  },
});
